/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Table, TableBody, TableContainer } from '@mui/material';
import React, { useEffect, useState } from 'react';
import WeeklyLogTableHead from './WeeklyLogTableHead';
import WeeklyLogTableRows from './WeeklyLogTableRows';
import { FlexBox, FlexBoxBetween } from '../../../components/tableItems';
import WeeklyLogTablePag from './WeeklyLogTablePag';
import { MainButton } from '../../../components/buttons';
import WeeklyLogSaveToolTip from '../Components/WeeklyLogSaveToolTip';
import WeeklyLogForm from '../Components/WeeklyLogForm';
import useWeeklyLogStore from '../../../stores/weeklyLog/WeeklyLogStore';
import Spinner from '../../../components/Loading/Spinner';

interface WeeklyLogTableProps {
  saveForm: () => Promise<void>;
}

const WeeklyLogTable: React.FC<WeeklyLogTableProps> = ({ saveForm }) => {
  const { loading, weeklyLogFetchResponse, formWeeklyLog, loadingSave } =
    useWeeklyLogStore();
  const [page, setPage] = useState(0);
  const [disabledSave, setDisabledSave] = useState(false);

  const checkValidation = () => {
    if (formWeeklyLog.length === 0) {
      setDisabledSave(true);
      return;
    }
    const weekends = ['saturday', 'sunday'];
    const checkAllNotWeekend = formWeeklyLog.filter((item, index) => {
      const { day_name } = weeklyLogFetchResponse[index];
      return (
        !weekends.includes(day_name.toLowerCase()) &&
        (item.follow_ups === null || item.responses_sent === null)
      );
    });
    setDisabledSave(checkAllNotWeekend.length > 0);
  };

  useEffect(() => {
    checkValidation();
  }, [formWeeklyLog]);

  return (
    <Box>
      <Box pr={2} mb={1.5}>
        <WeeklyLogTablePag page={page} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '50vh' }}>
        <Box
          sx={{
            overflow: 'auto',
            backgroundColor: 'white',
            flexGrow: 1,
          }}
          className="table_container"
        >
          <TableContainer
            style={{ tableLayout: 'fixed', display: 'table', width: '100%' }}
          >
            {loading && <Spinner />}
            {!loading &&
              weeklyLogFetchResponse.length > 0 &&
              weeklyLogFetchResponse.length === formWeeklyLog.length && (
                <Table
                  aria-labelledby="tableTitle"
                  sx={{
                    borderRight: '1px solid #d9d9d9',
                    backgroundColor: 'white',
                    borderCollapse: 'collapse',
                  }}
                >
                  <WeeklyLogTableHead />
                  <TableBody>
                    <WeeklyLogTableRows />
                  </TableBody>
                </Table>
              )}
          </TableContainer>
        </Box>
      </Box>
      {!loading && (
        <FlexBoxBetween px={2} mt={2}>
          <WeeklyLogForm loadingSave={loadingSave} saveForm={saveForm} />
          <FlexBox>
            <MainButton
              loading={loadingSave}
              variant="contained"
              sx={{
                background: '#BAF372',
                fontSize: 12,
                color: 'black',
                '&:hover': {
                  backgroundColor: '#BAF372',
                },
              }}
              disabled={
                disabledSave ||
                loadingSave ||
                !weeklyLogFetchResponse.find(
                  item => item.status !== 'completed',
                )
              }
              onClick={saveForm}
            >
              Save
            </MainButton>
            <WeeklyLogSaveToolTip />
          </FlexBox>
        </FlexBoxBetween>
      )}
    </Box>
  );
};

export default WeeklyLogTable;
